/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Shot_MeetingsInputs */

const en_tut_shot_meetings = /** @type {(inputs: Tut_Shot_MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Meeting page: a card of the next internal meetings with countdowns, followed by the list of meetings that have not started.`)
};

const id_tut_shot_meetings = /** @type {(inputs: Tut_Shot_MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Meeting: kartu jadwal internal berikutnya berisi tiga rapat dengan hitung mundur, lalu daftar rapat yang belum dimulai.`)
};

/**
* | output |
* | --- |
* | "The Meeting page: a card of the next internal meetings with countdowns, followed by the list of meetings that have not started." |
*
* @param {Tut_Shot_MeetingsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_shot_meetings = /** @type {((inputs?: Tut_Shot_MeetingsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Shot_MeetingsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_shot_meetings(inputs)
	return en_tut_shot_meetings(inputs)
});